import React from "react";
import * as Icons from "react-bootstrap-icons";
import PropTypes from "prop-types";

const CustomBootstrapIcon = ({
  icon,
  foreground = "black",
  size
}) => {
  const IconComponent = Icons[icon];

  if (!IconComponent) {
    console.error(`Icon "${icon}" not found in react-bootstrap-icons`);
    return null;
  }

  return (
    <IconComponent size={size} color={foreground} />
  );
};

CustomBootstrapIcon.propTypes = {
  icon: PropTypes.string.isRequired,       // Must match a valid export from react-bootstrap-icons
  background: PropTypes.string,
  foreground: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding: PropTypes.string,
  borderRadius: PropTypes.string,
};

export default CustomBootstrapIcon;



